
import { Record } from 'immutable';
import { actionTypes } from './layout.actions';


/**
 * Keep track of an item in the side nav bar.
 * navItemType:  string.  Default: null.  What type of item are we keeping track of?  'provider' and 'create-new-location' are the currently supported choices.
 * provId:  number.  If navItemType is 'provider', this will be the provider id.  If navItemType is 'create-new-location', this will be null.
 */
export const NavDetail = Record({
  navItemType: null,
  provId:  null
});

/**
 * Keep track of the keys pressed during keyboard navigation
 * at certain strategic points.
 * navbarCollapsed:  bool.  Default: true.  Always true for the moment--this functionality has not been affected.
 * navFromKey:  number.  Default:  null.  Represents the code of the keystroke from the side nav bar that we care about.  This comes from the onKeyDown event:  e.keyCode || e.which
 * navDetail:  object.  Default:  new NavDetail.  Contains details about the item in the side nav bar that corresponds to the navFromKey keystroke.  (See definition of NavDetail record.)
 * tabFromKey:  number.  Default:  null.  Represents the code of the keystroke from the tab control that we care about.  This comes from the onKeyDown event:  e.keyCode || e.which
 * tabId:  string.  Default:  null.  The id of the tab that was affected by the tabFromKey keystroke.  'tab-attributes', 'tab-services-provided', and 'tab-pending-updates' are the currently supported choices.
 */
export const LayoutState = Record({
  navbarCollapsed: true,
  navFromKey: null,
  navDetail: new NavDetail(),
  tabFromKey: null,
  tabId: null
});


export const layoutReducer = (state = new LayoutState(), action) => {
  switch (action.type) {
    case actionTypes.EXPAND_NAVBAR:
      return state.set('navbarCollapsed', false);
    case '@@router/LOCATION_CHANGE':
    case actionTypes.COLLAPSE_NAVBAR:
      return state.set('navbarCollapsed', true);
    case actionTypes.SET_NAV_FROM_KEY:
      if ( action.keycode === 13 ) {
        return state.set('navFromKey', action.keycode)
                    .set('navDetail', action.navdetail);
      }
      return state;
    case actionTypes.UNSET_NAV_FROM_KEY:
      return state.set('navFromKey', null)
                  .set('navDetail', null);
    case actionTypes.SET_TAB_FROM_KEY:
      return state.set('tabFromKey', action.keycode)
                  .set('tabId', action.tabname);
    case actionTypes.UNSET_TAB_FROM_KEY:
      return state.set('tabFromKey', null)
                  .set('tabId', null);
    default:
      return state;
  }
}
